exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".beneficios-inicio__layout{color:#fff;background-color:#043263;padding:32px 16px 8px}.beneficios-inicio__imagen{margin-bottom:32px;width:100%}.beneficios-inicio__titulo{font-family:BentonSansBBVA Bold;font-size:26px;line-height:32px}.beneficios-inicio__texto{font-size:15px;line-height:24px;margin-top:8px}.beneficios-inicio__beneficios{margin-top:16px}@media screen and (min-width:800px){.beneficios-inicio__layout{padding-bottom:96px;padding-left:96px}.beneficios-inicio__contenedor{max-width:458px}.beneficios-inicio__titulo{font-size:26px}.beneficios-inicio__texto{font-size:18px}.beneficios-inicio__beneficio-titulo{font-size:15px}.beneficios-inicio__beneficios{margin-top:24px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":false}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null]}!./src/css/components/BannerInicio/BannerInicio.css
// module id = 713
// module chunks = 8